import { REWARD_OFFERING } from "../../constants";
import CompetitionPage from "../../common/components/CompetitionPage";

function SummerGiveawayExtraMain() {
  const offerId = REWARD_OFFERING.summerGiveawayExtra;

  return (
    <CompetitionPage
      offerId={offerId}
    />
  );
}

export default SummerGiveawayExtraMain;
